import { IAuthRepository } from '../../domain/repositories/auth.repository.interface';
import { ITokenStorage } from '../interfaces/token-storage.interface';
import { LoginRequestDTO } from '../dtos/login-request.dto';
import { Session } from '../../domain/entities/session.entity';

export class LoginUserUseCase {
  constructor(
    private readonly authRepository: IAuthRepository,
    private readonly tokenStorage: ITokenStorage
  ) {}

  public async execute(request: LoginRequestDTO): Promise<Session> {
    const session = await this.authRepository.login({
      email: request.email,
      password: request.password,
    });

    // Persistir sesión usando la abstracción de almacenamiento
    this.tokenStorage.setToken(session.token);
    this.tokenStorage.setUser(session.user.toJSON());

    return session;
  }
}
